<form fxLayout="column" name="activity-{{ activityId }}">
  <div fxLayout="row" fxLayoutAlign="start center">
    <mat-form-field appearance="outline" class="time">
      <mat-label>Orario</mat-label>
      <input
        type="time"
        name="time"
        matInput
        [ngModel]="activity.time?.toDate() | date: 'HH:mm'"
        (ngModelChange)="
          activity.time = firestoreTimestampTimeAdapterService.getTimestamp(
            activity.time,
            $event
          )
        "
        [ngModelOptions]="{ updateOn: 'blur' }"
        required
      />
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline">
      <mat-label>Tipo Attività</mat-label>
      <mat-select
        [disabled]="disabled"
        [(ngModel)]="activity.type"
        name="type"
        (ngModelChange)="activity.reservationId = null"
        required
      >
        <mat-option *ngFor="let type of activityTypesData" [value]="type.key">
          {{ type.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container [ngSwitch]="activity.type">
      <span>&nbsp;&nbsp;</span>
      <mat-form-field
        appearance="outline"
        *ngSwitchCase="'ACCOMODATION'"
        fxFlex
      >
        <mat-label>Prenotazione sistemazione</mat-label>
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <mat-option
            *ngFor="let accomodation of itinerary.reservations.accomodations"
            [value]="accomodation.id"
          >
            {{ accomodationReservationToString(accomodation) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        *ngSwitchCase="
          activity.type == 'CAR' ||
          activity.type == 'MOTO' ||
          activity.type == 'CAMPER' ||
          activity.type == 'BIKE' ||
          activity.type == 'SCOOTER' ||
          activity.type == 'QUAD'
            ? activity.type
            : null
        "
        fxFlex
      >
        <mat-label
          >Prenotazione
          {{ getActivityTypeData(activity.type).label }}</mat-label
        >
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <mat-option
            *ngFor="let car of getCarReservationsWithType(activity.type)"
            [value]="car.id"
          >
            {{ transportationReservationToString(car) }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngSwitchCase="'FLIGHT'" fxFlex>
        <mat-label>Prenotazione Volo</mat-label>
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <ng-container *ngFor="let flight of itinerary.reservations.flights">
            <mat-option *ngFor="let route of flight.routes" [value]="route.id">
              {{ transportationReservationToString(route) }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngSwitchCase="'BUS'" fxFlex>
        <mat-label>Prenotazione Autobus</mat-label>
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <ng-container *ngFor="let bus of itinerary.reservations.buses">
            <mat-option *ngFor="let route of bus.routes" [value]="route.id">
              {{ transportationReservationToString(route) }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngSwitchCase="'TRAIN'" fxFlex>
        <mat-label>Prenotazione Treno</mat-label>
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <ng-container *ngFor="let train of itinerary.reservations.trains">
            <mat-option *ngFor="let route of train.routes" [value]="route.id">
              {{ transportationReservationToString(route) }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" *ngSwitchCase="'FERRY'" fxFlex>
        <mat-label>Prenotazione Nave</mat-label>
        <mat-select
          [(ngModel)]="activity.reservationId"
          name="reservationId"
          [disabled]="disabled"
        >
          <mat-option [value]="null">
            Nessuna prenotazione
          </mat-option>
          <ng-container *ngFor="let ferry of itinerary.reservations.ferries">
            <mat-option *ngFor="let route of ferry.routes" [value]="route.id">
              {{ transportationReservationToString(route) }}
            </mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>

  <div fxLayout="row" fxLayoutAlign="center center">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Titolo</mat-label>
      <input
        name="title"
        matInput
        [(ngModel)]="activity.title"
        type="text"
        required
      />
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline">
      <mat-label>Durata (ore)</mat-label>
      <input
        matInput
        name="duration-hours"
        type="number"
        min="0"
        step="1"
        [(ngModel)]="activity.duration.hours"
      />
    </mat-form-field>
    <span>&nbsp;&nbsp;</span>
    <mat-form-field appearance="outline">
      <mat-label>Durata (minuti)</mat-label>
      <input
        matInput
        name="duration-minutes"
        type="number"
        min="0"
        step="1"
        [(ngModel)]="activity.duration.minutes"
      />
    </mat-form-field>
    <ng-container *ngIf="!activity.reservationId">
      <span>&nbsp;&nbsp;</span>
      <mat-form-field appearance="outline" style="width: 300px;">
        <mat-label>Posizione su Mappa</mat-label>
        <mat-icon matSuffix>place</mat-icon>
        <app-lat-lng-input
          [disabled]="disabled"
          [(value)]="activity.place"
          [searchText]="activity.title"
          required
        ></app-lat-lng-input>
      </mat-form-field>
    </ng-container>
  </div>

  <div fxLayout="row" fxLayoutAlign="center start">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Descrizione</mat-label>
      <textarea
        style="height: 199px;"
        name="description"
        matInput
        [(ngModel)]="activity.description"
      ></textarea>
      <app-inline-help-button
        *ngIf="
          activity.type == 'METRO' ||
          activity.type == 'TRAM' ||
          activity.type == 'BUS'
        "
        matSuffix
        [title]="'Link maggiori informazioni'"
        [content]="
          'Aggiungi anche qualche informazione tipo da dove prendere il mezzo, dove comprare i biglietti, il numero della linea, la direzione, ecc.'
        "
      >
      </app-inline-help-button>
    </mat-form-field>
    <ng-container *ngIf="!activity.reservationId">
      <span>&nbsp;&nbsp;</span>
      <app-itinerary-image-form-field
        [disabled]="disabled"
        [(image)]="activity.image"
        [label]="'Foto *'"
      ></app-itinerary-image-form-field>
    </ng-container>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    *ngIf="!activity.reservationId"
  >
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Link maggiori informazioni</mat-label>
      <input
        name="link"
        matInput
        [(ngModel)]="activity.link.longUrl"
        type="url"
      />
    </mat-form-field>
    <app-inline-help-button
      *ngIf="activity.type == 'FOOD'"
      matSuffix
      [title]="'Link maggiori informazioni'"
      [content]="
        'Inserisci un link alla pagina web del ristorante o al profilo su TripAdvisor.'
      "
    >
    </app-inline-help-button>
    <app-inline-help-button
      *ngIf="activity.type == 'DISCOVER'"
      matSuffix
      [title]="'Link maggiori informazioni'"
      [content]="
        'Inserisci un link alla pagina web di riferimento o ad un eventuale sito ufficiale dove comprare i biglietti, se necessario.'
      "
    >
    </app-inline-help-button>
  </div>

  <div
    fxLayout="row"
    fxLayoutAlign="start center"
    *ngIf="!activity.reservationId"
  >
    <mat-form-field appearance="outline" style="width: 250px;">
      <mat-label>Prezzo totale per {{ itinerary.npax }} persone</mat-label>
      <input name="cost" matInput [(ngModel)]="activity.price" type="number" />
      <mat-icon matSuffix>euro_symbol</mat-icon>
    </mat-form-field>
  </div>
</form>
